import { useState } from 'react';
import { MDBBtn, MDBIcon } from 'mdb-react-ui-kit';

const ThemeToggle = () => {
  const [isDark, setIsDark] = useState(localStorage.getItem('theme') === 'dark');

  const toggleTheme = () => {
    const newIsDark = !isDark;
    setIsDark(newIsDark);
    
    if (newIsDark) {
      document.body.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.body.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  };

  return (
    <MDBBtn
      color="link"
      className="px-3 my-0 text-white"
      onClick={toggleTheme}
    >
      <MDBIcon 
        icon={isDark ? 'sun' : 'moon'} 
        fas 
        className="fa-lg"
      />
    </MDBBtn>
  );
};

export default ThemeToggle;